module.exports = __webpack_public_path__ + "img/asmi-logo.a724600f.png";